module.exports = __webpack_public_path__ + "media/images/logo-e673a2c50a74573984b8cae2b87f13ea.svg";